export default __webpack_public_path__ + "static/media/Bracers of Brutal Carnage.a5b841ed.jpg";